var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 8.00002C6.6665 7.26364 7.26346 6.66669 7.99984 6.66669C8.73622 6.66669 9.33317 7.26364 9.33317 8.00002C9.33317 8.7364 8.73622 9.33335 7.99984 9.33335C7.26346 9.33335 6.6665 8.7364 6.6665 8.00002Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 3.33333C6.6665 2.59695 7.26346 2 7.99984 2C8.73622 2 9.33317 2.59695 9.33317 3.33333C9.33317 4.06971 8.73622 4.66667 7.99984 4.66667C7.26346 4.66667 6.6665 4.06971 6.6665 3.33333Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 12.6667C6.6665 11.9303 7.26346 11.3333 7.99984 11.3333C8.73622 11.3333 9.33317 11.9303 9.33317 12.6667C9.33317 13.4031 8.73622 14 7.99984 14C7.26346 14 6.6665 13.4031 6.6665 12.6667Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dots.da6497d6c70402675f7de5661c04ca9b.svg";